export const nuggetLabels = {
  // Team page nugget
  team_page_nugget_title: {
    en: '💡 Tip of the week: your Team overview',
    nl: '💡 Tip van de week: je Team-overzicht',
    fr: '💡 Astuce de la semaine : votre vue Équipe',
  },
  team_page_nugget_text: {
    en: 'Colleagues are already noticing it: with Wundo, following up on your 1:1s gets a lot easier. For each team member you see right away where you stand, with all past and upcoming conversations.',
    nl: "Collega's merken het al: met Wundo wordt het opvolgen van je 1-2-1's een stuk eenvoudiger. Per teamlid zie je meteen waar je staat, met alle voorbije en geplande gesprekken.",
    fr: 'Vos collègues le remarquent déjà : avec Wundo, le suivi de vos 121 devient bien plus simple. Pour chaque membre de votre équipe, vous voyez tout de suite où vous en êtes, avec tous les entretiens passés et prévus.',
  },
  team_page_nugget_team_action: {
    en: 'Go to your team page',
    nl: 'Naar je teampagina',
    fr: "Vers votre page d'équipe",
  },
  team_page_nugget_help_action: {
    en: 'Read more',
    nl: 'Lees meer',
    fr: 'En savoir plus',
  },
  // Ask Wundo nugget
  ask_wundo_nugget_title: {
    en: '💡 Action of the week: ask Wundo',
    nl: '💡 Actie van de week: vraag het aan Wundo',
    fr: '💡 Action de la semaine\u00a0: demandez à Wundo',
  },
  ask_wundo_nugget_text: {
    en: 'You can always ask me something about your team here, based on your own conversations. Click a question to ask it right away:',
    nl: 'Je kan me hier altijd iets vragen over je team, op basis van je eigen gesprekken. Klik op een vraag om ze meteen te stellen:',
    fr: 'Vous pouvez toujours me poser ici une question sur votre équipe, à partir de vos propres entretiens. Cliquez sur une question pour la poser directement\u00a0:',
  },
  ask_wundo_nugget_footer: {
    en: 'Or ask your own question in the chat',
    nl: 'Of stel zelf een vraag in de chat',
    fr: 'Ou posez votre propre question dans le chat',
  },
  /*
   * The questions are sent as the user's own words when tapped, so French says
   * "tu", as people write to Wundo. `{name}` is a colleague's full name.
   */
  ask_wundo_nugget_about: {
    en: 'What have I already discussed with {name}?',
    nl: 'Wat heb ik al besproken met {name}?',
    fr: 'De quoi ai-je déjà parlé avec {name}\u00a0?',
  },
  ask_wundo_nugget_tell: {
    en: 'I want to give you some context about {name} before my next 1:1',
    nl: 'Ik wil je wat context geven over {name} voor mijn volgende 1:1',
    fr: 'Je veux te donner un peu de contexte sur {name} avant mon prochain 1:1',
  },
  ask_wundo_nugget_practice: {
    en: 'I want to practise a conversation',
    nl: 'Ik wil een gesprek oefenen',
    fr: "Je veux m'entraîner à un entretien",
  },
  ask_wundo_nugget_practice_library: {
    en: 'Which conversations can I practise?',
    nl: 'Welke gesprekken kan ik oefenen?',
    fr: 'Quels entretiens puis-je pratiquer\u00a0?',
  },
  /* `{topic}` is a short noun phrase with its article: "het leiderschapstraject". */
  ask_wundo_nugget_raise: {
    en: 'I want to discuss {topic} in my next 1:1 with {name}',
    nl: 'Ik wil {topic} bespreken in mijn volgende 1:1 met {name}',
    fr: 'Je veux aborder {topic} lors de mon prochain 1:1 avec {name}',
  },
  ask_wundo_nugget_add_point: {
    en: 'I want to add a point to my next 1:1 with {name}',
    nl: 'Ik wil een punt toevoegen aan mijn volgende 1:1 met {name}',
    fr: 'Je veux ajouter un point à mon prochain 1:1 avec {name}',
  },
  ask_wundo_nugget_prepare: {
    en: 'How do I prepare a good 1:1?',
    nl: 'Hoe bereid ik een goed 1:1-gesprek voor?',
    fr: 'Comment bien préparer un 1:1\u00a0?',
  },
  /* `{day}` is one of the `ask_wundo_nugget_day_*` phrases: "van maandag". */
  ask_wundo_nugget_report: {
    en: 'What was discussed in my 1:1 with {name} {day}?',
    nl: 'Wat werd er besproken in mijn 1:1 met {name} {day}?',
    fr: 'De quoi a-t-on parlé à mon 1:1 avec {name} {day}\u00a0?',
  },
  ask_wundo_nugget_debrief: {
    en: 'I want to debrief the 1:1 I had with {name} {day}',
    nl: 'Ik wil mijn 1:1 met {name} {day} nabespreken',
    fr: 'Je veux débriefer mon 1:1 avec {name} {day}',
  },
  ask_wundo_nugget_calendar: {
    en: 'How do I connect my calendar to Wundo?',
    nl: 'Hoe koppel ik mijn agenda aan Wundo?',
    fr: 'Comment connecter mon agenda à Wundo\u00a0?',
  },
  ask_wundo_nugget_day_today: {
    en: 'today',
    nl: 'van vandaag',
    fr: "d'aujourd'hui",
  },
  ask_wundo_nugget_day_yesterday: {
    en: 'yesterday',
    nl: 'van gisteren',
    fr: "d'hier",
  },
  /* `{weekday}` is the day's name as the language writes it: "maandag", "lundi". */
  ask_wundo_nugget_day_this_week: {
    en: 'on {weekday}',
    nl: 'van {weekday}',
    fr: 'de {weekday}',
  },
  ask_wundo_nugget_day_last_week: {
    en: 'last {weekday}',
    nl: 'van vorige {weekday}',
    fr: 'de {weekday} dernier',
  },
  /* `{date}` is the day and the month: "2 oktober". */
  ask_wundo_nugget_day_date: {
    en: 'on {date}',
    nl: 'van {date}',
    fr: 'du {date}',
  },
  // Roleplay nugget
  roleplay_nugget_kicker: {
    en: 'Action of the week',
    nl: 'Actie van de week',
    fr: 'Action de la semaine',
  },
  roleplay_nugget_title: {
    en: 'Practise a challenging conversation!',
    nl: 'Oefen een uitdagend gesprek!',
    fr: 'Essayez un jeu de rôle',
  },
  roleplay_nugget_intro: {
    en: "Wundo plays the other person, so you can already say out loud what you want to say. Not going the way you'd like? Then simply try again.",
    nl: 'Wundo speelt de andere persoon, zodat jij al eens hardop kan zeggen wat je wil zeggen. Loopt het niet zoals je wil? Dan probeer je gewoon opnieuw.',
    fr: "Wundo joue l'autre personne, pour que vous puissiez déjà dire à voix haute ce que vous voulez dire. Ça ne se passe pas comme prévu ? Vous recommencez, tout simplement.",
  },
  /* `{title}` is the roleplay's title in bold, with its full stop; `{situation}` one sentence. */
  roleplay_nugget_this_week: {
    en: 'This week for you: {title} {situation}',
    nl: 'Deze week voor jou: {title} {situation}',
    fr: 'Cette semaine pour vous : {title} {situation}',
  },
  roleplay_nugget_step_situation: {
    en: '**The situation**: you read what it is about and who you are talking to. You choose: speak or type.',
    nl: '**Situatie**: je leest waar het over gaat en met wie je praat. Je kiest: spreken of typen.',
    fr: '**La situation** : vous découvrez le contexte et votre interlocuteur. Vous choisissez : parler ou écrire.',
  },
  roleplay_nugget_step_feedback: {
    en: '**Instant feedback**: after the conversation you see what went well and one thing to try.',
    nl: '**Meteen feedback**: na het gesprek zie je wat goed liep en één ding om te proberen.',
    fr: '**Un feedback immédiat** : à la fin, vous voyez ce qui a bien fonctionné et un point à essayer.',
  },
  roleplay_nugget_step_review: {
    en: "**Read it back**: go over your conversation again, with Wundo's remarks.",
    nl: '**Lees het na**: je gesprek nog eens nalezen, met de opmerkingen van Wundo.',
    fr: '**Relisez** : relisez votre conversation, avec les remarques de Wundo.',
  },
  roleplay_nugget_footnote: {
    en: '5 to 10 minutes · only you see your conversation',
    nl: '5 à 10 minuten · alleen jij ziet je gesprek',
    fr: '5 à 10 minutes · vous êtes la seule personne à voir votre conversation',
  },
  roleplay_nugget_action: {
    en: 'Start roleplay',
    nl: 'Start rollenspel',
    fr: 'Lancer le jeu de rôle',
  },
  /* The second button on the card, and what the chat shows as the user's message when tapped. */
  roleplay_nugget_remind_action: {
    en: 'Remind me later',
    nl: 'Herinner mij later',
    fr: 'Rappelez-moi plus tard',
  },
  /* What Wundo asks when that button is tapped; the days follow as buttons. */
  roleplay_nugget_remind_question: {
    en: 'When should I send you this roleplay again? You can also type another day.',
    nl: 'Wanneer mag ik je dit rollenspel opnieuw sturen? Je kan ook zelf een dag typen.',
    fr: 'Quand dois-je vous renvoyer ce jeu de rôle ? Vous pouvez aussi écrire un autre jour.',
  },
  /* The first day offered for that reminder, when it is tomorrow. */
  roleplay_nugget_remind_tomorrow: {
    en: 'Tomorrow',
    nl: 'Morgen',
    fr: 'Demain',
  },
} as const satisfies Record<string, Record<string, string>>;
